import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { collectDefaultValueFromTargets } from './collect-default-value-from-targets.js'

export function collectDefaultValueFromSourceNames(fields: SchemaField[]): Set<string> {
  return new Set(collectDefaultValueFromTargets(fields).map((target) => target.sourceName))
}
